import { useMutation, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { budgetForecastApi } from 'src/Services/API';
import { UpsertBudgetForecastDto } from 'src/Services/API/generated';

/**
 * Wizard save path: the replace-all `PUT` of the budget-forecast module. The API soft deletes
 * the previous lines of the year and recreates the submitted ones in one transaction, so the
 * whole year is saved atomically.
 */
const useSaveBudgetYear = () => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dto: UpsertBudgetForecastDto) => {
      if (!assetId) throw new Error('No assetId provided');
      return (await budgetForecastApi.budgetForecastControllerUpsertLines(assetId, dto)).data;
    },
    onSuccess: (_data, variables) => {
      // Prefix key: invalidates the year, the suggestions and the tracking at once.
      queryClient.invalidateQueries(['budget', assetId, variables.year]);
      queryClient.invalidateQueries(['fetch-budget-forecast', assetId, variables.year]);
      queryClient.invalidateQueries(['fetch-budget-forecast-view', assetId]);
      queryClient.invalidateQueries(['fetch-expense-stats', assetId]);
    },
  });
};

export default useSaveBudgetYear;
